export { default as Icon } from './icon'
